import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import Color from '../Color.mjs'
import meta from './metaCatMd.mjs'

/**
 * MD 知识分类节点。
 * 固定节点对应 domain-knowledge 的第一层目录；子目录同为 CAT_MD，叶子为 MDM 模件。
 */
export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return 'MDM' === type || 'CAT_MD' === type
        },

        getStyle(map, node) {
            return {
                ...CategoryNode.getStyle.call(this, map, node),
                backgroundColor: Color.SKY_BLUE,
            }
        },

        // 同一层级存在多个 CAT_MD 节点（10 个固定目录），
        // 不能沿用分类节点“同类型固定节点替换”的逻辑。
        async _atAttach(map, node, event) {
            await this._atImport(map, node, event)
        },
    })
}
